import {useDispatch, useSelector} from 'react-redux';
import FormEditor from '../../atoms/jsonFormEditor/FormEditor';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';
import {getViews} from '../../../store/views/selectors';
import {getElementOnFocus, getImageMapData} from '../../../store/global/selectors';
import {findClusterletMappedParentID, findSelectedSchema} from '../../../services/builder/util';
import {useEffect, useState} from 'react';
import {handleSnackBar, invokeGetService, invokePostService, resetImageMapData, setDashboardRefresh, setFocusElement, setImageMapData} from '../../../store/global/actions';
import {generateWidgetSchema, generateWidgetSchemaValues, organizeWidgetData, widgetFormValidation} from '../../../services/entities/DashboardBuilder';
import {findTriggerEvent, formatConstraintToDropdownValues} from '../../../utils/commonUtils';
import {findChildren} from '../../../services/entities/simulations';
import {findHelperText, injectInlineHelperText, updateViewSchema} from '../../../utils/DashboardBuilder';
import {alertMessaage} from '../../../config/fields';
import {editView} from '../../../store/views/actions';
import './style.css';
import { widgetGroups } from '../../../config/common';
import SkeletonLoader from '../../atoms/loader/SkeletonLoader';

let options = {
  form_name_root: 'ui',
  show_errors: 'never',

  disable_array_delete_all_rows: true,
  disable_array_delete_last_row: true,
  disable_array_reorder: true,
};

const WidgetForm = ({parentID, onClose, id, action, rootId, type, selectedWidget, setSelectedWidget}) => {
  const dispatch = useDispatch();

  const elementOnFocus = useSelector(getElementOnFocus);
  const {url, areas, asset} = useSelector(getImageMapData);

  const view = useSelector(getViews);
  const schemas = view?.view_schema || [];

  let selectedChild = id ? findSelectedSchema({schemas: schemas || [], id}) : null;
  let oldType = null;
  if(selectedWidget && selectedChild){
    oldType =  selectedChild.type
    selectedChild.type = selectedWidget.value;
  }

  const [formSchema, setFormSchema] = useState();
  const [loading, setLoading] = useState(true);
  const [schemaValues, setSchemaValues] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
  const [clusterletList, setClusterletList] = useState([]);
  const [transactionList, setTransactionList] = useState([]);
  const [eventFields, setEventFields] = useState([]);
  const [allEvents, setAllEvents] = useState([]);
  const [allCLusterlets, setAllClusterlets] = useState([]);
  const [allMessages, setAllMessages] = useState([]);
  const [allFields, setAllFields] = useState([]);
  const [extendedFieldsData, setExtendedFieldsData] = useState([]);
  const [fieldsHistory, setFieldsHistory] = useState(null);
  const [renderIconSelector, setRenderIconSelector] = useState(false);
  const [alertMessage] = useState(alertMessaage);
  const [messageExtensionsRequired, setMessageExtensionsRequired] = useState( (selectedChild?.type === "html_form" || selectedWidget?.value === "html_form") ? true : false );


  const makeNameReadOnly = selectedChild !== undefined && selectedChild?.viewCopy === true ? true : false;

  const generateNestedMessageFields = (messageFields) => {
    try {
      
    
    function generateNested(data) {
      return data.map((item) => {
        let newObj = {
          id: item._id,
          name: item.name,
          type: item.attributes.type,
          desc: item.attributes.desc ? item.attributes.desc : '',
          optional: item.attributes.optional,
          children: [],
        };

        if (item.attributes.default && item.attributes.default !== '') {
          newObj.default = item.attributes.default;
        }

        if (item?.attributes?.constraint && item?.attributes.constraint !== '') {
          newObj.constraint = item.attributes.constraint;
        }

        if (item.children) {
          newObj.children = generateNested(item.children.map((child) => ({...child})));
        }

        if (newObj.constraint) newObj.constraint = formatConstraintToDropdownValues(newObj.constraint);

        return newObj;
      });
    }

    let eventFields = generateNested(messageFields);
    return eventFields;

    } catch (error) {
      console.error( `Generating nested message fields failed. ${error}`);
      return [];
    }
  };

  const formatFields = (eventId) => {
    try {
      
   
    let selectedEvent = allEvents.find((ev) => ev._id === eventId);
    let eventMessage = allMessages.find((msg) => msg._id === selectedEvent.message);

    if (selectedEvent === undefined) {
      return [];
    }

    let newData = findChildren(eventMessage, [], allFields);

    let formattedEventFileds = generateNestedMessageFields(newData.children);
    return formattedEventFileds;

    } catch (error) {
      console.error(`Formating fields failed. ${error}`);
      return [];
    }
  };

  const fetchBlueprintConstructs = () => {
    dispatch(invokeGetService('getBlueprintConstructs', [])).then((resp) => {
      if (resp.status) {
        setClusterletList(resp.data?.clusterlets?.filter((item) => item.type === 2 || item.type === 3));
        setTransactionList(resp.data?.transactions?.filter((item) => item.type === 7));
        setAllEvents(resp.data?.events);
        setAllClusterlets(resp.data?.clusterlets);
        setAllMessages(resp?.data?.messages);
        setAllFields(resp?.data?.fields);
      }

      setFormSchema(
        generateWidgetSchema({
          transactionList: resp.data?.transactions?.filter((item) => item.type === 7),
          clusterletList: resp.data?.clusterlets?.filter((item) => item.type === 2 || item.type === 3),
          viewsList: resp.data?.views,
          selectedChild
        }),
      );

      setSchemaValues(
        generateWidgetSchemaValues({
          selectedChild,
          fields: resp?.data?.fields,
          transactions: resp.data?.transactions,
          clusterlets: resp.data?.clusterlets,
          events: resp.data?.events,
          messages: resp?.data?.messages,
          widgetType: selectedWidget,
          setEventFields,
          setFieldsHistory,
          setExtendedFieldsData
        }),
      );

      setLoading(false);
    });
  };

  
  // Modify query paramete in hyperlink form elements
  const handleHyperlinkQueryParametersInForm = () => {
    try {
      
      const containers = document.querySelectorAll('[data-schemapath="ui.type.hyperlink.urlType.queryParameters"]');
      if (containers) {
        containers?.forEach((container, index) => {
        
          // 1. Change grid size from col-md-12 → col-md-6
          container.classList.remove("col-md-12");
          container.classList.add("col-md-6");
      
          // 2. Change Add Row button text
          const addBtn = container.querySelector(".json-editor-btn-add");
          if (addBtn) {
            addBtn.title = "";
            const span = addBtn.querySelector("span");
            if (span) span.textContent = " Add query parameter";
          }
      
          // 3. Insert label "Custom arguments" before the table if not present
          if (!document.getElementById(`custom-arguments-label-${index}`)) {
            const table = container.querySelector("table");
            if (table) {
              const label = document.createElement("div");
              label.id = `custom-arguments-label-${index}`;
              label.textContent = "Add more query parameters for the hyperlink";
              label.style.marginBottom = "5px";
              label.style.marginTop = "8px";
              table.parentNode.insertBefore(label, table);
            }
          }
        
      })

      }
    } catch (error) {
      console.error(`Handling hyperlink query parameters in the widget form failed. ${error}`);     
    }
  }

  const onChangeJsonEditor = (values) => {

    handleHyperlinkQueryParametersInForm();

    if (values !== undefined && values?.type !== undefined && values?.type?.settertransaction !== undefined) {
      const transactionData = transactionList?.find((txn) => txn._id == values?.type?.settertransaction);
      const triggerringEvent = findTriggerEvent({transaction: transactionData, events: allEvents, clusterlets: allCLusterlets});
      if (fieldsHistory != null && fieldsHistory[transactionData?._id]) {
        setEventFields(fieldsHistory[transactionData?._id]);
        setExtendedFieldsData(fieldsHistory[transactionData?._id]);
      } else {
        setEventFields(triggerringEvent ? formatFields(triggerringEvent._id) : []);
        setExtendedFieldsData(triggerringEvent ? formatFields(triggerringEvent._id) : []);
      }
    }

    if (values && values?.type && values?.type?.icon === 'custom_icon') {
      setRenderIconSelector(true);
    } else {
      setRenderIconSelector(false);
    }

    if(values?.type?.html_form){
      const viewElement = "getter";
      const helperText = findHelperText("form_operations", viewElement)
      injectInlineHelperText({
        formId: "ui-editor",
        schemaPath: "ui.type.gettertransaction",
        helperText: helperText
      })

      const setterElement = "setter";
      const setterhelpertext = findHelperText("form_operations", setterElement)
      injectInlineHelperText({
        formId: "ui-editor",
        schemaPath: "ui.type.settertransaction",
        helperText: setterhelpertext
      })
    }


  };

  const onCloseEditor = () => {
    dispatch(resetImageMapData());
    onClose();
  };

  const onUpdateForm = (data) => {
    setIsUpdating(true);
    const widgetData = organizeWidgetData({
      data,
      extendedFieldsData,
      eventFields,
      action,
      asset,
      url,
      areas,
      selectedWidgetData: selectedChild,
      oldType
    });


    const updatePayload = {};

    if (action === 'edit') {
      updatePayload.id = elementOnFocus.id;
      updatePayload.updatedData = {...widgetData};
    } else {
      updatePayload.parentId = elementOnFocus.parentID;
      updatePayload.newItem = {...widgetData};
    }
    const updatedViewData = updateViewSchema(view, action === 'create' ? 'add' : 'edit', updatePayload);
    if (action === 'create') {
      dispatch(editView(updatedViewData));
      dispatch(setDashboardRefresh({type: 'widget', action: 'create', entity: widgetData, parent: elementOnFocus.parentID}));  // Db update is doing after render for getting the position 
      dispatch(setFocusElement({type, id: updatePayload.newItem.id, action: 'edit', name: updatePayload.newItem.name, widgetType:  widgetData?.type}));
      setIsUpdating(false);
    } else if (action === 'edit') {

      onSave(updatedViewData, widgetData);
      dispatch(setDashboardRefresh({type: 'widget', action: 'edit', entity: widgetData}));
    }
  };

  const onSave = (saveData, widgetData) => {
    dispatch(invokePostService('updateView', {view: saveData}, [rootId])).then((response) => {
      if (response.status === true) {
        dispatch(handleSnackBar({ open: true, message: `Widget updated`, severity: 'success' }));
        dispatch(editView(saveData));
        dispatch(setFocusElement({type, id: selectedChild.id, action: 'edit', name: widgetData.name, widgetType: widgetData?.type}));
      }
      setIsUpdating(false);
    });
  };

  useEffect(() => {
    dispatch(resetImageMapData());
    fetchBlueprintConstructs();
    dispatch(setImageMapData({id}));
  }, []);

  useEffect(() => {
    if(selectedChild){
      let widget = widgetGroups.flatMap(item => item.widgets).find(item => item.value === selectedChild.type);
      setSelectedWidget(widget)
    }
  },[selectedChild])

  return (
    <>
      {loading && <SkeletonLoader type="form" isLabelled rows={6} />}
      {!loading && formSchema && (
        <>
          {((selectedWidget !== undefined && selectedWidget?.value === 'html_form') || (selectedChild !== undefined && selectedChild?.type === 'html_form')) && (
            <FormEditor
              options={options}
              schema={formSchema}
              onSave={onUpdateForm}
              onClose={onCloseEditor}
              schemaValues={schemaValues}
              validation={() => []}
              key={id}
              id={id}
              action={action}
              parentID={parentID}
              rootId={rootId}
              customValidation={widgetFormValidation}
              isUpdating={isUpdating}
              nameReadOnly={makeNameReadOnly}
              onChangeJsonEditor={onChangeJsonEditor}
              jsonRequired={true}
              eventFields={eventFields}
              setExtendedFieldsData={setExtendedFieldsData}
              isAlertRequired={alertMessage}
              messageExtensionsRequired={messageExtensionsRequired}
              setMessageExtensionsRequired={setMessageExtensionsRequired}
            />
          )}

          {selectedWidget?.value !== 'html_form' && selectedChild?.type !== 'html_form' && (
            <FormEditor
              options={options}
              schema={formSchema}
              onSave={onUpdateForm}
              onClose={onCloseEditor}
              schemaValues={schemaValues}
              validation={() => []}
              key={id}
              id={id}
              action={action}
              parentID={parentID}
              rootId={rootId}
              customValidation={widgetFormValidation}
              isUpdating={isUpdating}
              nameReadOnly={makeNameReadOnly}
              onChangeJsonEditor={onChangeJsonEditor}
              renderCustomIconSelector={renderIconSelector}
              messageExtensionsRequired={messageExtensionsRequired}
              setMessageExtensionsRequired={setMessageExtensionsRequired}
            />
          )}
        </>
      )}
    </>
  );
};


export default WidgetForm;